import {
  Component,
  OnInit,
  Pipe,
  PipeTransform,
  OnDestroy,
  HostListener,
  ElementRef,
  TemplateRef,
  AfterViewInit,
  ViewChild,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  Router,
  RouterModule,
  ActivatedRoute,
  Event,
  NavigationStart,
  NavigationEnd,
  NavigationError,
} from "@angular/router";
import {
  Location,
  LocationStrategy,
  PathLocationStrategy,
} from "@angular/common";

import { DomSanitizer } from "@angular/platform-browser";
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFireDatabase } from "@angular/fire/database";
import { AngularFireStorage } from "@angular/fire/storage";

import { SitedataService } from "../Services/sitedata.service";
import { MsgBrokerService } from "../Services/msg-broker.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { SpeechService } from "../Services/speech.service";
import { LinksService } from "../Services/links.service";

import { Observable, Subscription, Subject } from "rxjs";
import { fromEvent, interval, merge, of, timer } from "rxjs";
import { mapTo, scan, map, filter, switchMap } from "rxjs/operators";
import { repeatWhen, takeUntil } from "rxjs/operators";

import swal from "sweetalert2";

@Pipe({ name: "safe" })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  selector: "app-canvas",
  templateUrl: "./canvas.component.html",
  styleUrls: ["./canvas.component.scss"],
})
export class CanvasComponent implements OnInit, OnDestroy {
  modalRef: BsModalRef;
  // subscriptions
  routerParamSub: Subscription;
  authSub: Subscription;
  saveSub: Subscription;
  timerSub: Subscription;
  isCollapsed: boolean = true;
  sidenavOpen: boolean = true;

  private myTemplate: any = "";
  newURL = "";
  title = "";
  titleTextMode = true;
  myExternalPageLink = "https://www.overleaf.com/";
  isSessionAvailable = false;
  sessionId;
  note: Object = {};
  noteId='';
  currentUser;
  currentUserId='';
  noteText;
  capturedLinksForNote = [];
  unlinkedLinksArray = [];
  files: File[] = [];
  uploadPercent;

  cannotLoadUrlInPage = false;
  noteWords;
  savedMessage;

  linkCaptureProgress = 0;
  clearTextContentForUrl;

  
/**
 * Views object allows to set flags to show or hide specific containers
 */
  viewers = {
    pageViewer: false,
    imageViewer: false,
    uploadViewer: true,
    linkPlaceholder: true,
    captureContainer: true,
    writingCanvas: true,
    imageCarousel: true,
    videoCarousel: true,
    linkCarousel: true,
    audioCarousel: true,
    documentsCarousel: true,
  };

  showPreview;
  previewImageUrl;
  noteStatus;

  /**
   * Configuration for quill editor
   */
  quillModule = {
    // toolbar: '.toolbar'
    toolbar: [
      ["bold", "italic"],
      ["link", "blockquote", "code", "image", "video"],
      [{ header: 1 }, { header: 2 }, { header: 3 }],
      [
        {
          list: "ordered",
        },
        {
          list: "bullet",
        },
      ],
      ["save"],
    ],
  };

  isMobileResolution: boolean;
  limitedWidth: boolean;
  timerValue;
  totalTimeElapsed: number = 0;
  currentTimeElapsed: number = 0;
  timerRunning: boolean = false;
  showViewerOverlay: boolean = false;

  private readonly _stop = new Subject<void>();
  private readonly _start = new Subject<void>();
  constructor(
    private siteData: SitedataService,
    private speechService: SpeechService,
    private linksService: LinksService,
    private msgBrokerService: MsgBrokerService,
    private router: Router,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private element: ElementRef,
    private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    public afAuth: AngularFireAuth,
    private db: AngularFireDatabase,
    private storage: AngularFireStorage
  ) {
    if (window.innerWidth < 1200) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }

    this.location = location;

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        // Show loading indicator
      }
      if (event instanceof NavigationEnd) {
        // Hide loading indicator

        if (window.innerWidth < 1200) {
          document.body.classList.remove("g-sidenav-pinned");
          document.body.classList.add("g-sidenav-hidden");
          this.sidenavOpen = false;
        }
      }
      if (event instanceof NavigationError) {
  
      }
    });

    /**
     * Handle the flags set from the side bar. NOT NEEDED NOW
     */
    // this.msgBrokerService.viewerSelected$.subscribe((viewer) => {
    //   this.showAreas(viewer);
    // });

  }
  @HostListener("window:resize", ["$event"])
  isMobile(event) {
    if (window.innerWidth < 1200) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }
  }

  /**
   * Initialize the component variables.
   * Get the current user and authentication status
   * Get the route parameters
   * Get the note data
   */
  async ngOnInit() {
    try {
      let currentUser: any = await this.checkAuthenticationStatus();
      let routeParams: any = await this.getRouteParams();
      this.noteStatus = "active";
      if (routeParams.hasOwnProperty("status")) {
        this.noteStatus = routeParams.status ? "active": "archived";
      }
      if (
        currentUser.hasOwnProperty("uid") &&
        routeParams.hasOwnProperty("id")
      ) {
        this.noteId = routeParams.id;
        this.currentUser = currentUser;
        this.currentUserId = currentUser.uid;
        this.getNote(routeParams.id, currentUser.uid);
        this.showAreas('links');
        this.viewers.linkCarousel = true;
        /**
         * Following are commented as the bookmarks are now being shown from the reference component
         */
        this.getCapturedLinksForNote(currentUser.uid, routeParams.id);
        this.getUnlinkedBookmarks(currentUser.uid);
      } else {
        if (!currentUser.hasOwnProperty("uid")) {
          this.router.navigate(["/signin"]);
        } else {
          this.router.navigate(["/notes"]);
        }
      }
    } catch (e) {
      
    }
  }

  /**
   * Save the link to the note from the capture link box
   */
  async loadNewURL(newURL) {
    try {
      /**
         * Set the progress of link capture to manage button status
         */
        this.linkCaptureProgress = 1;
        // let timerFunction = setTimeout(() => {
        //   this.linkCaptureProgress++;
        // }, 250);
        swal.fire({
          title: "Capturing!",
          text: `We are capturing your link and extracting content. 
          The link will be availble to you as soon as the process is over.
          Meanwhile, you can continue with your work.`,
          icon: "info",
        });
      let updatedLinkData = await this.updateNewLink(newURL);
      this.getCapturedLinksForNote(this.currentUserId, this.noteId);
      this.linkCaptureProgress = 0;
      // clearTimeout(timerFunction);
    } catch (error) {
      
    }
    
  }

  //TODO: Change the logic to resemble the data structure from the browser extensions.
  async updateNewLink(newURL) {
    return new Promise(async (resolve, reject) => {
      try {

        // Get the link object array for the note
        // If doesn't exist, create afresh
        // Add the link to the object array
        // Update the note
        
        let existingLinks =
          (<any>this.note).links && (<any>this.note).links.length > 0
            ? (<any>this.note).links
            : [];
        let existingLinksCount = existingLinks.length;
        let newLinkObject = {
          linkUrl: newURL,
        };
        

        // // TODO Shift the Open graph logic to server
        // // this.updateOpenGraphData(existingLinksCount, this.newURL);
        // // TODO Shift the clear text logic to server
        let updatedLinkData = await this.updateClearTextData(existingLinksCount, newURL);
        newLinkObject["type"]="link";
        newLinkObject["title"] = (<any>updatedLinkData).title;
        existingLinks.push(newLinkObject);
        existingLinksCount = existingLinks.length;
        (<any>this.note).links = existingLinks;
        
        
        let db = this.db.database;
        let commonLinksRef = db.ref("/captures/" + this.currentUser.uid + '/links');
        let newLinkRef = commonLinksRef.push();
        let linkObject = {
          "title": "",
          "url": this.newURL,
          'type': 'link',
          "id": newLinkRef.key
        }
        newLinkRef.set(linkObject);
        let lastLinkSavedId =newLinkRef.key;
        this.newURL = '';
        resolve(lastLinkSavedId);
        } catch (error) {
          reject(error);
        }
    });
  }

  // TODO: Check if this function will still be needed if the logic for updating the link remains similar to the browser extensions
  async updateClearTextData(existingLinksCount, url) {
    return new Promise(async (resolve, reject) => {
      try {
        var newLinkRef = this.db.database
          .ref(
            "/Notes/" +
              this.currentUser.uid +
              "/" + this.noteStatus + "/" +
              (<any>this.note).id +
              "/links"
          )
          .push();
        var newLinkId = newLinkRef.key;
        let notesData = {
          id: newLinkId,
          linkUrl: url,
          lastUpdate: Date.now(),
        };

        let clearTextData = await this.getClearTextData(url);
        notesData["siteData"] = clearTextData;
        notesData["title"]= (<any>clearTextData).title;
        notesData["type"] = "link";
        newLinkRef.set(notesData);
        this.newURL = "";
        this.savedMessage = "Note saved.";
        this.linkCaptureProgress = 0;
        this.titleTextMode = true;
        setTimeout(() => {
          this.savedMessage = "";
        }, 2000);
        resolve(notesData);
      } catch (error) {
        reject(error);
      }
    });
  }

  // TODO: Check if this function will still be needed if the logic for updating the link remains similar to the browser extensions
  getClearTextData(url) {
    return new Promise((resolve, reject) => {
      this.siteData.getClearText(url).subscribe(
        (ogsDataObject) => {
          resolve(ogsDataObject);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  // TODO: Check if removing this is okay. It is not being called from anywhere as such.
  updateOpenGraphData(existingLinksCount, url) {
    this.siteData.getOpenGraphData(this.newURL).subscribe(
      (ogsDataObject) => {
        (<any>this.note).links[existingLinksCount - 1].siteData = ogsDataObject;
        this.updateNote();
      },
      (error) => {
        // Try to save the link without OGS data
        this.updateNote();
      }
    );
  }

  /**
   * Get the user id if authenticated user is found
   */
  checkAuthenticationStatus() {
    return new Promise((resolve, reject) => {
      this.authSub = this.afAuth.user.subscribe((user) => {
        if (user) {
          resolve(user);
        } else {
          reject(false);
        }
      });
    });
  }

  /**
   * Get the route params
   */
  getRouteParams() {
    return new Promise((resolve, reject) => {
      this.routerParamSub = this.activatedRoute.params.subscribe((params) => {
        if (params) {
          resolve(params);
        } else {
          reject(false);
        }
      });
    });
  }

  /**
   * Get a specific note
   * @param noteId
   */
  async getNote(noteId, userId) {
    this.db
      .object("/Notes/" + userId + "/" + this.noteStatus + "/" + noteId)
      .snapshotChanges()
      .subscribe(async (snapshot) => {
        
        this.note = snapshot.payload.val();
        this.totalTimeElapsed = (<any>this.note).timeSpent
            ? +(<any>this.note).timeSpent
            : 0;
        this.timerValue = this.formatTimeToShow(this.totalTimeElapsed);
        // Convert links object to an array
        if ((<any>this.note).links) {
          this.note["linksArray"] = this.convertObjectToArray(
            (<any>this.note).links
          );
        }
        if (!this.note) {
          this.note = {};
        }
        try {
          // Get the temporary copy of the content that was saved automatically.
          // Compare if auto-saved content should be used if the save time was later than manual save time.
          let tempNote = await this.getTempNote(noteId, userId);
          if (
            tempNote &&
            (<any>tempNote).tempNotes.length > (<any>this.note).notes.length
          ) {
            (<any>this.note).notes = (<any>tempNote).tempNotes;
          }
          (<any>this.note).timeSpent =
            (<any>this.note).timeSpent &&
            +(<any>tempNote).timeSpent > +(<any>this.note).timeSpent
              ? +(<any>tempNote).timeSpent
              : +(<any>this.note).timeSpent;
          this.totalTimeElapsed = (<any>this.note).timeSpent
            ? +(<any>this.note).timeSpent
            : 0;
          this.timerValue = this.formatTimeToShow(this.totalTimeElapsed);
          
          
          

          // Convert images object to an array
          if ((<any>this.note).images) {
            this.note["imagesArray"] = this.convertObjectToArray(
              (<any>this.note).images
            );
          }

          if ((<any>this.note).videos) {
            this.note["videosArray"] = this.convertObjectToArray(
              (<any>this.note).videos
            );
          }

          if ((<any>this.note).audios) {
            this.note["audiosArray"] = this.convertObjectToArray(
              (<any>this.note).audios
            );
          }

          if ((<any>this.note).documents) {
            this.note["documentsArray"] = this.convertObjectToArray(
              (<any>this.note).documents
            );
          }
          if (!(<any>this.note).notes){
            (<any>this.note).notes = "";
          }
          
        } catch (_error) {}

        this.viewers.imageCarousel =
          this.note &&
          (<any>this.note).imagesArray &&
          (<any>this.note).imagesArray.length > 0
            ? true
            : false;
        this.viewers.videoCarousel =
          this.note &&
          (<any>this.note).videos &&
          (<any>this.note).videosArray.length > 0
            ? true
            : false;
        this.viewers.linkCarousel =
          this.note &&
          (<any>this.note).links &&
          Object.keys((<any>this.note).links).length > 0
            ? true
            : false;
        this.viewers.audioCarousel =
          this.note &&
          (<any>this.note).audios &&
          (<any>this.note).audiosArray.length > 0
            ? true
            : false;
        this.viewers.documentsCarousel =
          this.note &&
          (<any>this.note).documents &&
          (<any>this.note).documentsArray.length > 0
            ? true
            : false;
        
        this.splitNoteToWords();
        this.startAutoSave();
      });
  }

  /**
   * Get the links captured via the browser extension and assigned to current note
   * Add it to Notes linkArray created at the runtime
   * @param userId, noteId
   */
  async getCapturedLinksForNote(userId, noteId) {
    
    this.db
      .list("/captures/" + userId + "/links", (ref) =>
        ref.orderByChild("noteId").equalTo(noteId)
      )
      .stateChanges(["child_added"])
      .subscribe(
        async (snapshot) => {
          
          // this.loadNewURL((<any>snapshot.payload.val()).url);
          try {
            let updatedLinkData = await this.updateNewLink((<any>snapshot.payload.val()).url);
            let deletedLink = await this.deleteCapturedLink((<any>snapshot.payload.val()).id, userId);
          } catch (error){
            
          }
        },
        (error) => {
          
        }
      );
  }

  /**
   * Delete the captured link after it is moved to the note links
   * @param capturedNoteId
   */
  deleteCapturedLink(capturedNoteId, userId) {
    let capturedLinkRef = this.db.database.ref('/captures/' + userId + '/links/' + capturedNoteId);
    capturedLinkRef.set(null);
    
  }


  
  /**
   * Get the bookmarks which have not yet been assigned to any project
   * These bookmarks come from browser extensions or mobile phones
   * @param userId 
   */
  getUnlinkedBookmarks(userId) {
    let capturedLinks = [];
    this.db
      .list("/captures/" + userId + "/links")
      .stateChanges(["child_added"])
      .subscribe( 
        async (snapshot) => {
          let bookmarkObject = (<any>snapshot).payload.val();
          if (bookmarkObject.type && (bookmarkObject.type === 'link' || bookmarkObject.type === 'page')) {
            if (!bookmarkObject.siteData) {
          
              //TODO: Update the bookmarks with cleartext data
              let clearTextData = await this.getClearTextData(bookmarkObject.url);
              bookmarkObject["siteData"] = clearTextData;
              let bookmarkRef = this.db.database.ref('/captures/' + userId + "/links/" + bookmarkObject.id);
              bookmarkRef.update({"siteData": clearTextData });
            }
            this.unlinkedLinksArray.push(bookmarkObject);
          }
          
        },
        (error) => {}
      );
  }

  convertObjectToArray(originalObject) {
    let newArray = [];
    Object.keys(originalObject).forEach((arrayItem) => {
      newArray.push(originalObject[arrayItem]);
    });
    return newArray;
  }

  getTempNote(noteId, userId) {
    return new Promise((resolve, reject) => {
      this.db
        .object("/TempNotes/" + userId + "/" + noteId)
        .query.once("value")
        .then((data) => {
          let tempNote = data.val();
          resolve(tempNote);
        })
        .catch((error) => {
          reject(false);
        });
    });
  }

  /**
   * Creates an anchor tag from a link
   * @param inputText
   */
  getConvertedLink(inputText) {
    var replacedText, replacePattern1, replacePattern2, replacePattern3;

    //URLs starting with http://, https://, or ftp://
    replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
    replacedText = inputText.replace(
      replacePattern1,
      '<a href="$1" target="_blank">$1</a>'
    );

    //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
    replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(
      replacePattern2,
      '$1<a href="http://$2" target="_blank">$2</a>'
    );

    //Change email addresses to mailto:: links.
    replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(
      replacePattern3,
      '<a href="mailto:$1">$1</a>'
    );

    return replacedText;
  }

  signout() {
    this.afAuth.signOut();
    this.router.navigate(["/signin"]);
  }

  saveNote() {
    let title =
      (<any>this.note).title.trim().length > 0
        ? (<any>this.note).title
        : (<any>this.note).link;
    let note =
      (<any>this.note).notes && (<any>this.note).notes.trim().length > 0
        ? (<any>this.note).notes
        : "";

    let notesData = {
      title: title,
      link: this.newURL,
      notes: note,
      timeSpent: this.totalTimeElapsed + this.currentTimeElapsed,
      date: Date.now(),
    };
    this.updateNote();

  }

  saveTempNote() {
    this.savedMessage = "Saving...";
    let note =
      (<any>this.note).notes && (<any>this.note).notes.trim().length > 0
        ? (<any>this.note).notes
        : "";

    let notesData = {
      date: Date.now(),
      tempNotes: note,
      timeSpent: this.totalTimeElapsed + this.currentTimeElapsed,
    };

    this.updateTempNote(notesData);

  }

  updateNote() {
    (<any>this.note).lastUpdate = Date.now();
    (<any>this.note).timeSpent =
      this.totalTimeElapsed + this.currentTimeElapsed;
    var currentNoteRef = this.db.database.ref(
      "/Notes/" + this.currentUser.uid + "/active/" + (<any>this.note).id
    );
    currentNoteRef.update(this.note);
    this.newURL = "";
    this.savedMessage = "Note saved.";
    this.linkCaptureProgress = 0;
    this.titleTextMode = true;
    setTimeout(() => {
      this.savedMessage = "";
    }, 2000);
  }

  updateTempNote(notesData) {
    
    var currentNoteRef = this.db.database.ref(
      "/TempNotes/" +
        this.currentUser.uid +
        "/" +
        (<any>this.note).id
    );

    currentNoteRef.update(notesData);
    this.newURL = "";
    this.savedMessage = "Saved";
    currentNoteRef = null;
    setTimeout(() => {
      this.savedMessage = "";
    }, 2000);
  }

  /**
   *
   * Add dropped or selected files to the array to be uploaded
   * @param event
   */
  onSelect(event) {
    this.files.push(...event.addedFiles);
  }

  /**
   * Remove files previously queued for upload
   * @param event
   */
  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  /**
   * Upload the files to data store
   */
  async uploadFiles() {
    //Assign files to a local array
    //Remove all files from the global queue
    //Upload the files to Firebase
    //Get the download url
    //Update notes. Push to the image array
    //Clear local array
    let tempFiles = this.files;
    let currentUser = await this.checkAuthenticationStatus();
    let noteId = (<any>this.note).id;
    let noteItems = [];

    tempFiles.forEach((fileItem, index) => {
      let fileType = this.getFileType(fileItem.type);
      let filePath;
      let nodeType;
      let noteItem = {};
      let itemIndex: number;
      if (fileType.trim().length > 0) {
        switch (fileType) {
          case "image":
            nodeType = "images";
            itemIndex = (<any>this.note).images
              ? Object.keys((<any>this.note).images).length
              : 0;
            break;
          case "audio":
            nodeType = "audios";
            itemIndex = (<any>this.note).audios
              ? Object.keys((<any>this.note).audios).length
              : 0;
            break;
          case "video":
            nodeType = "videos";
            itemIndex = (<any>this.note).videos
              ? Object.keys((<any>this.note).videos).length
              : 0;
            break;
          case "document":
            nodeType = "documents";
            itemIndex = itemIndex = (<any>this.note).documents
              ? Object.keys((<any>this.note).documents).length
              : 0;
            break;
          default:
            nodeType = "documents";
            itemIndex = itemIndex = (<any>this.note).documents
              ? Object.keys((<any>this.note).documents).length
              : 0;
            break;
        }
      }
      filePath =
        "/Notes/" +
        (<any>currentUser).uid +
        "/" +
        noteId +
        "/" +
        nodeType +
        "/" +
        ++itemIndex;
      (<any>noteItem).fileTitle = itemIndex.toString();
      (<any>noteItem).altText = "";
      
      const fileRef = this.storage.ref(filePath);
      const task = this.storage.upload(filePath, fileItem);

      // observe percentage changes
      this.uploadPercent = task.percentageChanges();
      // get notified when the download URL is available
      task.then(() => {
        fileRef.getDownloadURL().subscribe((url) => {
          (<any>noteItem).fileUrl = url;
          (<any>this.note).lastUpdate = Date.now();
          
          var currentNoteRef = this.db.database
            .ref(
              "/Notes/" +
                this.currentUser.uid +
                "/active/" +
                (<any>this.note).id +
                "/" +
                nodeType
            )
            .push();

          var newItemId = currentNoteRef.key;
          noteItem["id"] = newItemId;
          currentNoteRef.set(noteItem);

        });
      });
    });

    this.files = [];
    tempFiles = [];
  }

  /**
   * Get the content type based on file mime type.
   * @param type
   */
  getFileType(type) {
    let fileType: string = "";
    if (type.indexOf("audio") > -1) {
      fileType = "audio";
    } else if (type.indexOf("video") > -1) {
      fileType = "video";
    } else if (type.indexOf("image") > -1) {
      fileType = "image";
    } else {
      fileType = "document";
    }
    return fileType;
  }

  /**
   * Display the page, if allowed by security constraints. Otherwise, prompt user to view original page in a new tab.
   * @param url
   */
  displayUrlContent(note) {
    
    try {
      this.clearTextContentForUrl = note.siteData.content;
      this.viewers.pageViewer = true;
      this.showViewerOverlay = true;
      this.viewers.linkCarousel = false;
    } catch (e) {
      alert("Cannot view");
    }
  }

  deleteItem(link) {
    this.deleteNoteItem(link, "links");
  }

  pinToNote(link) {
    this.moveLinks(link);
  }
  async moveLinks(link) {
    
    let clearText = "";
    try {
    let currentUser = await this.checkAuthenticationStatus();
    if (link.type === 'page'|| link.type === 'link' && !link.siteData) {
      (<any>clearText) = await this.linksService.getClearTextData(link.url);
    }
    
    let newLinkRef = this.db.database
      .ref(
        "/Notes/" +
        (<any>currentUser).uid +
        "/" +
        (<any>this.note).id +
        "/links"
      )
      .push();
    var newLinkId = newLinkRef.key;
    let notesData = {
      id: newLinkId,
      linkUrl: link.url,
      lastUpdate: Date.now(),
    };

    if (link.type === 'page'|| link.type === 'link') {
      notesData["siteData"] = link.siteData ? link.siteData : clearText;
    }
    newLinkRef.set(notesData);
    // this.getCapturedLinks((<any>currentUser).uid);
  } catch (error) {
    // this.isLoading = false;
  }
  }

  deleteImage(image) {
    this.deleteNoteItem(image, "images");
  }

  deleteAudio(audio) {
    this.deleteNoteItem(audio, "audios");
  }

  deleteVideo(video) {
    this.deleteNoteItem(video, "videos");
  }

  deleteDocument(document) {
    this.deleteNoteItem(document, "documents");
  }

  deleteNoteItem(item, type) {
    swal
      .fire({
        title: "Are you sure to delete?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn btn-secondary",
        },
        buttonsStyling: false,
        confirmButtonText: "Yes, delete it!",
      })
      .then(async (result) => {
        if (result.value) {
          // Delete the link
          let currentUser = await this.checkAuthenticationStatus();
          var itemRef = this.db.database.ref(
            "/Notes/" +
              (<any>currentUser).uid +
              "/" +
              (<any>this.note).id +
              "/" +
              type +
              "/" +
              item.id
          );
          itemRef.set({});
          this.getNote((<any>this.note).id, (<any>currentUser).uid);

          // Show confirmation
          swal.fire({
            title: "Deleted!",
            text: "Your file has been deleted.",
            icon: "success",
          });
        }
      });
  }

  /**
   * Split the note into words array
   * And show the words count
   */
  splitNoteToWords() {
    if (!(<any>this.note) || !(<any>this.note).notes || (<any>this.note).notes =="") {
      this.noteWords = 0;
      return;
    }
    this.noteWords = (<any>this.note).notes
      ? (<any>this.note).notes.split(" ").length
      : "0";
  }

  startAutoSave() {
    // if (!(<any>this.note) || !(<any>this.note).notes || (<any>this.note).notes.length <= 0) {
    //   return;
    // }
    this.saveSub = interval(10000).subscribe((val) => {
      this.saveTempNote();
    });
  }

  showEnlargedImage(url) {
    this.showPreview = true;
    this.previewImageUrl = url;
    this.viewers.imageViewer = true;
  }

  closeImagePreview() {}

  showAreas(viewer) {
    switch (viewer) {
      case "capture":
        this.viewers.uploadViewer = true;
        this.viewers.pageViewer = false;
        this.viewers.linkCarousel = false;
        break;
      case "images":
        this.viewers.imageCarousel = (<any>this.note).images ? true : false;
        break;
      case "videos":
        this.viewers.videoCarousel = (<any>this.note).videos ? true : false;
        break;
      case "audio":
        this.viewers.audioCarousel = (<any>this.note).audios ? true : false;
        break;
      case "links":
        this.viewers.linkCarousel = (<any>this.note).links ? true : false;
        this.viewers.linkCarousel = true;
        break;
      case "documents":
        this.viewers.documentsCarousel = (<any>this.note).documents
          ? true
          : false;
        break;
      default:
        break;
    }
  }

  toggleCaptureContainer() {
    let anyCaptureModeOpen =
      this.viewers.uploadViewer ||
      this.viewers.imageCarousel ||
      this.viewers.videoCarousel ||
      this.viewers.audioCarousel ||
      this.viewers.linkCarousel ||
      this.viewers.documentsCarousel;
    this.viewers.uploadViewer =
      !anyCaptureModeOpen && this.viewers.captureContainer
        ? true
        : this.viewers.uploadViewer;
    // this.viewers.captureContainer = !anyCaptureModeOpen && this.viewers.captureContainer ? this.viewers.captureContainer : !this.viewers.captureContainer;
    this.viewers.captureContainer = !this.viewers.captureContainer;
  }

  openSidebar() {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
      this.sidenavOpen = false;
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
      this.sidenavOpen = true;
    }
  }
  toggleSidenav() {
    if (document.body.classList.contains("g-sidenav-pinned")) {
      document.body.classList.remove("g-sidenav-pinned");
      document.body.classList.add("g-sidenav-hidden");
      this.sidenavOpen = false;
    } else {
      document.body.classList.add("g-sidenav-pinned");
      document.body.classList.remove("g-sidenav-hidden");
      this.sidenavOpen = true;
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  /**
   * Start the time to calculate the time spent on this note.
   * For the first time, the totalTimeElapsed will be zero.
   * For each subsequent note visit, it would be set to the previously saved value.
   * Current elapsed time will be added to the initial value.
   * The total elapsed time will be saved to the temporary note node, along with the text content.
   * On load, it will be set to the original note.
   */
  startTimer() {
    this.timerValue = this.formatTimeToShow(this.totalTimeElapsed);
    let timerSub = timer(1000, 1000).pipe(
      takeUntil(this._stop),
      repeatWhen(() => this._start)
    );

    this.timerSub = timerSub.subscribe((given_seconds) => {
      this.timerRunning = true;
      if (this._start) {
        this.currentTimeElapsed = given_seconds;
      }
      // this.totalTimeElapsed = given_seconds;
      this.timerValue = this.formatTimeToShow(
        this.totalTimeElapsed + given_seconds
      );
    });
  }

  formatTimeToShow(elapsedTimeInSeconds) {
    let hours = Math.floor(elapsedTimeInSeconds / 3600);
    let minutes = Math.floor((elapsedTimeInSeconds - hours * 3600) / 60);
    let seconds = elapsedTimeInSeconds - hours * 3600 - minutes * 60;
    return (
      hours.toString().padStart(2, "0") +
      ":" +
      minutes.toString().padStart(2, "0") +
      ":" +
      seconds.toString().padStart(2, "0")
    );
  }

  restartTimer() {
    this.timerRunning = true;
    this._start.next();
  }

  stopTimer() {
    this.timerRunning = false;
    this._stop.next();
  }

  ngOnDestroy() {
    this.routerParamSub
      ? this.routerParamSub.unsubscribe()
      : (this.routerParamSub = null);
    this.authSub ? this.authSub.unsubscribe() : (this.authSub = null);
    this.saveSub ? this.saveSub.unsubscribe() : (this.saveSub = null);
  }

  closeViewerOverlay() {
    this.showViewerOverlay = false;
  }
  playAudio(url){
    let audio = new Audio();
    audio.src = url;
    audio.load();
    audio.play();
  }
  editorContentChanged(event) {
    this.noteText = event.text;
  }
  speakNow() {
    let note =
      (<any>this.note).notes && (<any>this.note).notes.trim().length > 0
        ? (<any>this.note).notes
        : "";
  let cleanText = this.noteText.replace(/[↵]/g, '');
    let data = {
      // The limit is 500 words/3000 characters at a time. For more, loop through the text chunks
      // Entities to be replaced: don't-do not, doesn't - does not, won't - will not
    text: this.noteText.replace(/[\n\r\"\'\;]/g, ''),
    voice: "Matthew"
  };
  this.speechService.speak(data).subscribe((result:any) => {
      this.playAudio(result.url);
    });

  }
}
